// extracted by mini-css-extract-plugin
export default {"container":"Spacestation_container__bB1ad","titleWrapper":"Spacestation_titleWrapper__W8xXx","img":"Spacestation_img__cuuPM"};